import { render, staticRenderFns } from "./PTuseLandNormalizedChart.vue?vue&type=template&id=5ca51ef1&scoped=true"
import script from "./PTuseLandNormalizedChart.vue?vue&type=script&lang=js"
export * from "./PTuseLandNormalizedChart.vue?vue&type=script&lang=js"
import style0 from "./PTuseLandNormalizedChart.vue?vue&type=style&index=0&id=5ca51ef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca51ef1",
  null
  
)

export default component.exports